import React from "react"
import { Label } from "@/components/shadcn/ui/label"
import { Input } from "@/components/shadcn/ui/input"
import { TextField as TextFieldType } from "@/models/new/forms.types"
import { ResponseValue, TextResponse } from "@/models/new/formResponse.types"

interface Props {
  field: TextFieldType
  value?: ResponseValue
  onChange: (fieldId: string, value: ResponseValue) => void
}

const StringField = (props: Props) => {
  const { field, value, onChange } = props

  const currentValue = value?.type === "text" ? (value as TextResponse).value : ""

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(field.id, {
      fieldName: field.name,
      type: "text",
      value: e.target.value,
    })
  }

  return (
    <React.Fragment>
      <div className="w-1/2 p-4">
        <div>
          <Label>{field.label}</Label>
          <Input value={currentValue} onChange={handleChange} className="bg-white mt-1" />
        </div>
      </div>
    </React.Fragment>
  )
}

export default StringField
